import { Row, Col } from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import { useContext, useEffect } from 'react';
import { getAllUsers } from '../../features/user/userSlice';

import { NotificationContext } from '../../providers/NotificationProvider';
import DataTable from '../shared/DataTable';
import { UserType } from '../../types/types';

const CompanyUsers: React.FC<{ company_id: number }> = ({ company_id }) => {
  const dispatch = useDispatch();
  const { triggerNotification } = useContext(NotificationContext);
  const { users } = useSelector((store: any) => store.user);

  const usersNotEmployees = users.filter((user: UserType) => user?.company?.id === company_id);

  useEffect(() => {
    dispatch(getAllUsers() as any)
      .then((result: any) => {
        if (getAllUsers.fulfilled.match(result)) {
          triggerNotification('success', 'Exito', 'Se cargaron los usuarios correctamente', 'bottomRight');
        } else {
          triggerNotification('error', 'Error', 'Error al cargar los usuarios', 'bottomRight');
        }
      })
      .catch((err: any) => {
        triggerNotification('error', 'Error', 'Error al cargar los usuarios', 'bottomRight');
      });
    // eslint-disable-next-line
  }, []);

  const buildDisplayName = (user: UserType) => {
    const clean = (value?: string | null) => (value && value !== 'N/A' ? value.trim() : '');
    const firstName = clean(user.first_name);
    const lastName = clean(user.last_name);
    const fullName = `${firstName} ${lastName}`.trim();
    return fullName || clean(user.username) || `Usuario ${user.id}`;
  };

  const usersWithDisplayName = usersNotEmployees.map((user: UserType) => ({
    ...user,
    display_name: buildDisplayName(user),
  }));

  const columns = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
    },
    {
      title: 'Nombre',
      dataIndex: 'display_name',
      key: 'display_name',
      searchable: true,
    },
    {
      title: 'Correo electrónico',
      dataIndex: 'email',
      key: 'email',
      searchable: true,
    },
    {
      title: 'Nombre de Usuario',
      dataIndex: 'username',
      key: 'username',
      searchable: true,
    },
  ];

  return (
    <Row className='content'>
      <Col style={{ width: '100%' }}>
        <h1>Empleados</h1>
        <div className='ant-divider'></div>
        <DataTable dataSource={usersWithDisplayName} columns={columns} inactiveFlag={'is_active' as never} />
      </Col>
    </Row>
  );
};

export default CompanyUsers;
